import { useWorkspacePadding } from '@components/v2/layout/hooks/useWorkspacePadding';
import { Box, Stack, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import useMeasuredWidth from '../../../../../../../hooks/useMeasuredWidth';

const COLUMN_GAP = 2.5;
const ROW_GAP = 4;
const DETAILS_MIN_WIDTH = 320;
const DETAILS_MAX_WIDTH = 487;
const SUMMARY_WIDTH = 291;

interface OrderConditionLayoutProps {
  navigator: ReactNode;
  details: ReactNode;
  summary?: ReactNode;
}

const OrderConditionLayout = ({ navigator, details, summary }: OrderConditionLayoutProps) => {
  const theme = useTheme();
  const { containerRef, width: rowWidth } = useMeasuredWidth();
  const { padding: workspacePadding } = useWorkspacePadding();

  const columnGapInPixels = Number.parseFloat(theme.spacing(COLUMN_GAP));
  const isSummaryBesideDetails = rowWidth >= DETAILS_MIN_WIDTH + columnGapInPixels + SUMMARY_WIDTH;

  return (
    <Stack
      sx={{
        gap: 2,
        width: '100%',
        maxWidth: `${DETAILS_MAX_WIDTH + SUMMARY_WIDTH + columnGapInPixels}px`,
        marginInline: 'auto',
        paddingRight: workspacePadding,
        boxSizing: 'border-box',
      }}
    >
      {navigator}

      <Stack
        ref={containerRef}
        direction="row"
        sx={{ flexWrap: 'wrap', alignItems: 'flex-start', columnGap: COLUMN_GAP, rowGap: ROW_GAP }}
      >
        <Box
          sx={{
            flex: `1 1 ${DETAILS_MIN_WIDTH}px`,
            maxWidth: isSummaryBesideDetails ? DETAILS_MAX_WIDTH : '100%',
            minWidth: 0,
          }}
        >
          {details}
        </Box>

        {summary && (
          <Box
            sx={{
              flex: `1 1 ${SUMMARY_WIDTH}px`,
              maxWidth: isSummaryBesideDetails ? SUMMARY_WIDTH : '100%',
              minWidth: 0,
            }}
          >
            {summary}
          </Box>
        )}
      </Stack>
    </Stack>
  );
};

export default OrderConditionLayout;
